import api from '../../../lib/Api'
import docServiceApi from '../../../lib/DocumentServiceApi'
import { push } from 'connected-react-router'
import { addNotification } from '../../notifications'
import {
  fetchingArchetypes,
  fetchingArchetypesSuccess,
  fetchingArchetypesError,
  fetchingLessonProgressReport,
  fetchingLessonProgressReportSuccess,
  fetchingLessonProgressReportError,
  fetchingNetsuiteCustomer,
  fetchingNetsuiteCustomerError,
  fetchingNetsuiteCustomerSuccess,
  fetchingProductUser,
  fetchingProductUserError,
  fetchingProductUserSuccess,
  fetchingSetupAdminUserId,
  fetchingSetupAdminUserIdError,
  fetchingSetupAdminUserIdSuccess,
  savingProductUser,
  savingProductUserError,
  savingProductUserSuccess,
  savingProductUserPakSuccess,
} from './actions'

export const fetchAndHandleArchetypes = () => {
  return async function(dispatch, getState) {
    const state = getState()
    const { userManager } = state
    if (userManager.archetypes.data) {
      return true
    }
    dispatch(fetchingArchetypes())

    try {
      const response = await api.get('/profile/archetypes')
      const data = response.data
      if (response.status === 200) {
        dispatch(fetchingArchetypesSuccess(data))
      }
    } catch (error) {
      dispatch(fetchingArchetypesError(error))
      dispatch(
        addNotification({
          color: 'danger',
          text: 'Failed to fetch user archetypes.',
        }),
      )
      return false
    }
  }
}

export const fetchAndHandleProductUser = (email, id) => {
  return async function(dispatch) {
    dispatch(fetchingProductUser())

    try {
      const response = await api.get(`profile/details?userId=${id}`)
      if (response.status === 204) {
        dispatch(fetchingProductUserSuccess(null))
        dispatch(
          push({
            pathname: '/css-admin/users',
            state: { email: email, id: id, notFound: true },
          }),
        )
      } else {
        dispatch(fetchingProductUserSuccess(response.data))
        dispatch(push(`/css-admin/users/${email}/${id}`))
      }
    } catch (error) {
      dispatch(fetchingProductUserError(error))
      return false
    }
  }
}

export const fetchSetupAdminUserId = setupAdminEmail => {
  return async dispatch => {
    dispatch(fetchingSetupAdminUserId())
    const response = await api.get(`/profile/search?email=${setupAdminEmail}`)
    try {
      if (!!response.data && response.data.length > 0) {
        const setupAdmin = response.data[0]
        const { id = null } = setupAdmin || {}
        dispatch(fetchingSetupAdminUserIdSuccess(id))
      } else {
        dispatch(fetchingSetupAdminUserIdError(new Error('No user found')))
      }
    } catch (error) {
      dispatch(fetchingSetupAdminUserIdError(error))
      return false
    }
  }
}

export const fetchNetsuiteCustomer = netsuiteCustomerId => {
  return async dispatch => {
    dispatch(fetchingNetsuiteCustomer())

    try {
      const response = await api.get(
        `/netsuitecustomers?netsuitecustomerid=${netsuiteCustomerId}`,
      )
      dispatch(fetchingNetsuiteCustomerSuccess(response.data[0]))
    } catch (error) {
      dispatch(fetchingNetsuiteCustomerError(error))
      return false
    }
  }
}

export const saveAndHandleProductUser = productUser => {
  return async function(dispatch) {
    dispatch(savingProductUser())

    try {
      const response = await api.put('/profile', productUser)
      //create new below
      dispatch(savingProductUserSuccess(response.data))
      dispatch(
        addNotification({
          color: 'success',
          text: 'Successfully saved user.',
        }),
      )
    } catch (error) {
      dispatch(savingProductUserError(`Error saving with status code ${error}`))
      dispatch(
        addNotification({
          color: 'danger',
          text: 'Failed to saved user.',
        }),
      )
    }
  }
}

export const removePakFromProductUser = pakNo => {
  return async function(dispatch, getState) {
    dispatch(savingProductUser())
    const productUser = getState().userManager.productUser

    try {
      const response = await api.delete(
        'admin/user/' + productUser.email + '/pak/' + pakNo,
      )
      dispatch(savingProductUserSuccess(response.data))
      dispatch(
        addNotification({
          color: 'success',
          text: 'Successfully removed pak.',
        }),
      )
    } catch (error) {
      console.error(error)
      dispatch(savingProductUserError(`Error saving with status code ${error}`))
      dispatch(
        addNotification({
          color: 'danger',
          text: 'Failed to remove pak.',
        }),
      )
    }
  }
}

export const addPakToProductUser = pakNo => {
  return async function(dispatch, getState) {
    const productUser = getState().userManager.productUser
    const addPakToProductUserPayload = {
      PakNumber: pakNo,
      UserId: productUser.id,
    }

    dispatch(savingProductUser())
    try {
      await api.post(`userpak`, addPakToProductUserPayload)
      dispatch(savingProductUserPakSuccess())
      dispatch(
        addNotification({
          color: 'success',
          text: 'Successfully added pak.',
        }),
      )

      // not ideal for updating PAK grid, will fix when api give a response
      const { id, email } = productUser || {}
      if (!!email && !!id) {
        dispatch(fetchAndHandleProductUser(email, id))
      }
      return true
    } catch (error) {
      console.error(error)
      dispatch(
        savingProductUserError(`Error adding pak with status code ${error}`),
      )
      dispatch(
        addNotification({
          color: 'danger',
          text: 'Failed to add pak.',
        }),
      )
    }
  }
}

export const fetchLessonProgressReport = (userEmail, programCode) => {
  return async dispatch => {
    dispatch(fetchingLessonProgressReport())
    try {
      const response = await docServiceApi.post('/SiteReport', {
        userEmail,
        program: programCode,
        options: {
          useFlexTemplate: true,
          useHsFullTemplate: true,
        },
      })
      const sasUrl = response.data.sasUrl
      dispatch(fetchingLessonProgressReportSuccess(sasUrl))
    } catch (error) {
      dispatch(fetchingLessonProgressReportError(error))
      dispatch(
        addNotification({
          color: 'danger',
          text: `Failed to get Lesson Progress Report for program ${programCode}`,
        }),
      )
    }
  }
}

export const clearLessonProgressReportLink = () => {
  return async dispatch => {
    dispatch(fetchingLessonProgressReportSuccess(null))
  }
}

export default {
  addPakToProductUser,
  clearLessonProgressReportLink,
  fetchAndHandleArchetypes,
  fetchAndHandleProductUser,
  fetchLessonProgressReport,
  fetchNetsuiteCustomer,
  fetchSetupAdminUserId,
  removePakFromProductUser,
  saveAndHandleProductUser,
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/userManager/operations.js